"use client";

import Link from "next/link";
import { useAppFeatureFlag } from "@/components/feature-flags/feature-flags-provider";

/**
 * Kill-switch-aware link to /features/enterprise-integrations for static
 * marketing pages (#1137 Codex review). That feature page 404s when an
 * operator kills the `site_control` tier, so a statically revalidated page
 * like /integrations must not link to it in that state.
 *
 * Same self-gating pattern as SiteControlPricingNote: reads the DB-backed
 * `site_control` flag from the marketing layout's AppFeatureFlagsProvider and
 * renders nothing when the flag is off, so the link appears and disappears in
 * lockstep with the rest of the Site Control surface.
 *
 * Renders as a sentence fragment — "<link>, the " — so the surrounding copy
 * stays grammatical with or without it: "see the [enterprise integrations
 * overview, the ]API documentation and the OpenAPI 3.1 spec."
 */
export function EnterpriseIntegrationsOverviewLink() {
  const enabled = useAppFeatureFlag("site_control");
  if (!enabled) return null;

  return (
    <>
      <Link
        href="/features/enterprise-integrations"
        className="font-semibold text-brand-700 hover:underline"
      >
        enterprise integrations overview
      </Link>
      , the{" "}
    </>
  );
}
